module.exports = __webpack_public_path__ + "img/cr.17879461.png";